import { BAFTA_IMPACT_FUND_SLUG, isBaftaUser, User } from "@ecologi/shared";
import { NavSection } from "@ecologi/react-components/src/NavigationDrawer/navigation";
import { accountDetailsPageTitle } from "../../features/profile/account-details/account-details-page-title";
import { isProduction } from "../../lib/utils/is-production";
import { getPhoenixUrl } from "../../lib";
import { addIdsToNavSection } from "./add-ids-to-nav-section";

export const getNavSectionsForFundPlatform = ({
  isPhoenixUser,
  user,
}: {
  isPhoenixUser: boolean;
  user: User;
}): NavSection[] => {
  const isBafta = isBaftaUser(user);
  const impactShopPath = isBafta
    ? `${getPhoenixUrl()}/impact-funds/${BAFTA_IMPACT_FUND_SLUG}?utm_source=WebApp&utm_medium=Navigation&utm_campaign=FundPlatformNav`
    : `${getPhoenixUrl()}/impact-marketplace?utm_source=WebApp&utm_medium=Navigation&utm_campaign=FundPlatformNav`;

  return [
    [
      {
        label: "Your profile",
        path: user.getProfilePath(),
        route: user.isChildProfile
          ? "/[usernameOrId]/[childUsernameOrId]"
          : "/[usernameOrId]",
      },
      {
        label: "Dashboard",
        path: "/dashboard",
      },
      {
        label: "Project insights",
        path: "/project-insights",
      },
      {
        label: "Impact shop",
        path: impactShopPath,
        route: impactShopPath,
        isOpenInNewTab: true,
      },
      {
        label: "Flight calculator",
        path: "/flights?utm_source=WebApp&utm_medium=Navigation&utm_campaign=FundPlatformNav",
        route: "/flights",
        isOpenInNewTab: true,
      },
      {
        label: "Badges",
        path: `/${user.username}/badges`,
        route: "/[usernameOrId]/badges",
      },
      ...(user.isBusinessType
        ? [
            {
              label: "Business toolkit",
              path: "/business-toolkit",
            },
            {
              label: "Impact API",
              path: "/impact-api",
            },
          ]
        : []),
      {
        label: "Account",
        links: [
          {
            label: accountDetailsPageTitle(user),
            path: "/account/details",
          },
          {
            label: "Profile settings",
            path: "/account/settings",
          },
          {
            label: "Billing",
            path: "/account/billing",
          },
          {
            label: "Manage subscription",
            path: "/account/manage-subscription",
          },
          {
            label: "Certificates",
            path: "/account/certificates",
          },
        ],
      },
    ],
    ...(user.isBusinessType
      ? [
          [
            {
              label: "Ecologi Zero",
              path: isProduction()
                ? "https://zero.ecologi.com/api/landing-redirect"
                : "https://x.zero.ecologi.com/api/landing-redirect",
            },
          ],
        ]
      : []),
    [
      {
        label: "Help centre",
        path: "https://help.ecologi.com/",
      },
      ...(isPhoenixUser
        ? [
            {
              label: "Switch to new app",
              path: getPhoenixUrl(),
              tag: { text: "beta" },
            },
          ]
        : []),
    ],
    [
      {
        label: " Logout",
        path: "/auth/logout",
      },
    ],
  ].map(addIdsToNavSection);
};
